/**
 * Detects if the current device is running iOS
 * @returns boolean indicating if the device is iOS
 */
export function isIOS(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

/**
 * Detects if the current device is running Android
 * @returns boolean indicating if the device is Android
 */
export function isAndroid(): boolean {
  return /Android/.test(navigator.userAgent);
}

/**
 * Detects if the current device is a mobile device
 * @returns boolean indicating if the device is mobile
 */
export function isMobile(): boolean {
  return isIOS() || isAndroid() || /Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian/.test(navigator.userAgent);
}

/**
 * Detects if the current browser supports fullscreen API
 * @returns boolean indicating if fullscreen is supported
 */
export function isFullscreenSupported(): boolean {
  return !!(
    document.fullscreenEnabled ||
    (document as any).webkitFullscreenEnabled ||
    (document as any).mozFullScreenEnabled ||
    (document as any).msFullscreenEnabled
  );
}

/**
 * Detects if the current browser supports iOS-style video fullscreen
 * @param videoElement - The video element to check
 * @returns boolean indicating if iOS video fullscreen is supported
 */
export function isIOSVideoFullscreenSupported(videoElement?: HTMLVideoElement): boolean {
  if (!isIOS()) return false;
  if (!videoElement) return false;
  
  return !!(videoElement as any).webkitEnterFullscreen;
}
